
export const COLUMNS = [
    {
        Header: 'Date',
        accessor: 'timestamp'
    },
]